export default "__VITE_ASSET__R_LH70ZI__"